import SaveIcon from "@mui/icons-material/Save";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  FormHelperText,
  FormControl,
  Select,
  MenuItem,
  Stack,
  Chip,
  Tabs,
  Tab,
} from "@mui/material";
import CustomFieldForm from "components/CustomFieldForm";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import { setHomePage, useMaterialUIController } from "context";
import useAuth from "hooks/useAuth";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
import { JsonTool } from "utils/jsonTools";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { API_URL, API_ROUTES, MenuProps } from "../../utils/constants";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Switch from "@mui/material/Switch";
import CustomTabPanel from "components/CustomPanel/customPanel";
import { DashboardCustomize, Settings } from "@mui/icons-material";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import "../tinTuc/formTinTuc.css";

export default function Setting() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const { accessToken, user } = useAuth();
  const toolBarRef = useRef(null);
  const axiosPrivateInstance = useAxiosPrivate();
  const setAlert = useSetRecoilState(AlertState);
  const [data, setData] = useState();
  const [dataEmail, setDataEmail] = useState(null);
  const [dataExtensionFile, setDataExtensionFile] = useState([]);
  const [values, setValues] = useState({
    showPass: false,
  });
  const [errors, setErrors] = useState();
  const [value, setValue] = useState(0);
  const myString = " Quy định tham số phải có dấu {{ tham số truyền }}";
  const handleChangeInput = (name) => (e) => {
    const { value } = e.target;
    setData((prev) => ({
      ...prev,
      fields: {
        ...prev?.fields,
        [name]: value,
      },
    }));
  };
  const fetchDataSetting = async () => {
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.SETTING + "/1"
      );
      const data = response.data;
      setData(data);
    } catch (error) {
      console.log(error);
      setAlert({
        alert: true,
        message: error?.message || "Lỗi!",
        type: "error",
      });
      return;
    }
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    const readFile = async () => {
      try {
        const response = await axiosPrivateInstance.get(
          `${API_URL}/api/v1/read-file/`
        );
        setDataEmail(response?.data ?? null);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    readFile();
  }, []);
  const onSubmitFormEmail = async () => {
    try {
      const response = await axiosPrivateInstance.post(
        `${API_URL}/api/v1/save-file`,
        { dataEmail }
      );
      setAlert({
        alert: true,
        message: "Lưu mẫu Email thành công!",
        type: "success",
      });
      return;
    } catch (error) {
      console.log(error);
      setAlert({
        alert: true,
        message: error?.message || "Lỗi!",
        type: "error",
      });
      return;
    }
  };
  //
  useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message ===
        "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
  }, []);
  useEffect(() => {
    const fetchDataExtension = async () => {
      try {
        const response = await axiosPrivateInstance.get(
          API_ROUTES.EXTENSIONFILE
        );
        setDataExtensionFile(response?.data);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    fetchDataExtension();
    if (user && user?.id) {
      fetchDataSetting();
    }
  }, [user]);

  const handleChangeMultiple = (key) => (e) => {
    let { value } = e.target;
    setData((prev) => ({
      ...prev,
      [key]: value?.length > 0 ? value : [],
    }));
  };
  const handleToDelete = (key, value) => (e) => {
    let newArr = data[key].filter((item) => item !== value);
    setData((prev) => ({
      ...prev,
      [key]: newArr || [],
    }));
  };
  const handlePassVisibilty = () => {
    setValues({
      ...values,
      showPass: !values.showPass,
    });
  };
  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...data };
    _data["id"] = 1;
    _data["name"] = "email";
    let validateForm = { ...data };
    delete validateForm?.fields;
    validateForm = {
      ...validateForm,
      ...data?.fields,
    };
    const newValidationErrors = validateOBJ(validateForm);
    let _tempValid = newValidationErrors;
    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      return;
    }
    axiosPrivateInstance
      .put(API_ROUTES.SETTING + "/" + _data?.id, { ..._data })
      .then((res) => {
        if (res && res.data) {
          setAlert({
            alert: true,
            message: "Cập nhập thành công!",
            type: "success",
          });
          //   fetchDataSetting();
        }
      })
      .catch((error) => {
        let validErrors = {};
        let data = error?.response?.data;
        if (Array.isArray(data)) {
          let value = "";
          value = data?.join(";");
          setAlert({
            alert: true,
            message: value,
            type: "error",
          });
          validErrors = { ...validErrors };
        } else {
          Object.entries(data).forEach(([key, value]) => {
            let val = "";
            if (Array.isArray(value)) {
              value.map((item) => {
                val += item;
              });
            } else {
              val = value;
            }
            validErrors = { ...validErrors, [key]: val };
          });
        }
        setErrors(validErrors);
      });
  }
  const fieldInfor = useMemo(() => {
    let result = [
      {
        name: "IP API cấp TW",
        key: "api_ocop_tw",
        type: "text",
        maxLength: 1000,
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Thư mục upload file",
        key: "folder_upload",
        type: "text",
        required: true,
        maxLength: 500,
        xs: 12,
        md: 12,
        lg: 12,
      },
    ];
    return result;
  }, []);
  const handleChangeDataState = (data) => {
    let { name, value } = data;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleErrorDataState = (error) => {
    let { name, value } = error;
    setErrors((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  //number
  const handleChangeValueInput = (name) => (e) => {
    let { value } = e.target;
    setData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const handleOnFocus = (name) => (e) => {
    e.stopPropagation();
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handleKeyDown = (event) => {
    // Kiểm tra xem phím đã được nhấn có phải là "."
    if (event.key === ".") {
      event.preventDefault(); // Loại bỏ phím "." nếu có
    }
  };
  const handleChangeAuth2 = (e) => {
    const { checked } = e.target;
    setData((prev) => ({
      ...prev,
      auth2: checked,
    }));
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box
        sx={{
          width: "100%",
          bgcolor: "background.paper",
          //borderBottom: 1,
          borderColor: "divider",
          padding: "1rem 1rem 0 1rem",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="primary"
          variant="fullWidth"
          aria-label="basic tabs example"
        >
          <Tab
            icon={<Settings />}
            label="Thiết lập hệ thống"
            {...JsonTool.a11yProps(0)}
          />
          <Tab
            icon={<DashboardCustomize />}
            label="Mẫu Email thông báo"
            {...JsonTool.a11yProps(1)}
          />
        </Tabs>
      </Box>
      <Box
        sx={{
          bgcolor: "background.paper",
        }}
      >
        <CustomTabPanel value={value} index={0}>
          <CustomFieldForm
            key={"fieldInfor"}
            listField={fieldInfor}
            data={data}
            onChange={handleChangeDataState}
            onError={handleErrorDataState}
            errorValues={errors}
            listOptionDic={{}}
          />
          <Grid container spacing={2} sx={{ textAlign: "left" }} mt={"0px"}>
            <Grid item xs={12} md={4} lg={4}>
              <Typography
                fontSize={"0.75rem"}
                color={"#000000"}
                fontWeight={500}
              >
                Số năm hết hạn
              </Typography>
              <TextField
                fullWidth
                name={"sonam_hethan"}
                value={data?.sonam_hethan || 0}
                error={errors ? !!errors?.sonam_hethan : false}
                placeholder={`Nhập số năm hết hạn`}
                helperText={errors?.sonam_hethan}
                onChange={handleChangeValueInput("sonam_hethan")}
                type="number"
                onFocus={handleOnFocus("sonam_hethan")}
                inputProps={{ pattern: "[0-9]*" }}
                onKeyDown={handleKeyDown}
                InputProps={{
                  inputProps: {
                    style: { textAlign: "right" },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <Typography
                fontSize={"0.75rem"}
                color={"#000000"}
                fontWeight={500}
              >
                Dung lượng file cho phép upload (MB)
              </Typography>
              <TextField
                fullWidth
                name={"dungluong_file_upload"}
                value={data?.dungluong_file_upload || 0}
                error={errors ? !!errors?.dungluong_file_upload : false}
                placeholder={`Nhập số năm hết hạn`}
                helperText={errors?.dungluong_file_upload}
                onChange={handleChangeValueInput("dungluong_file_upload")}
                type="number"
                onFocus={handleOnFocus("dungluong_file_upload")}
                inputProps={{ pattern: "[0-9]*" }}
                onKeyDown={handleKeyDown}
                InputProps={{
                  inputProps: {
                    style: { textAlign: "right" },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <MDBox
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                mt={3}
                lineHeight={1}
              >
                <MDTypography variant="h6">Xác thực 2 lớp</MDTypography>
                <Switch
                  checked={data?.auth2 || false}
                  onChange={handleChangeAuth2}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Typography
                fontSize={"0.75rem"}
                color={"#000000"}
                fontWeight={500}
              >
                Chọn thành phần file mở rộng{" "}
                <span style={{ color: "red" }}>*</span>
              </Typography>
              <FormControl fullWidth>
                <Select
                  multiple
                  sx={{ padding: "0.75rem" }}
                  name={"extension"}
                  value={
                    dataExtensionFile?.length > 0 && data && data.extension
                      ? data.extension
                      : []
                  }
                  MenuProps={MenuProps}
                  error={errors ? !!errors?.extension : false}
                  onChange={handleChangeMultiple("extension")}
                  onFocus={handleOnFocus("extension")}
                  required={true}
                  renderValue={(selected) => {
                    return (
                      <Stack gap={1} direction="row" flexWrap="wrap">
                        {data.extension?.length > 0 &&
                          selected?.length > 0 &&
                          selected.map((value) => (
                            <Chip
                              key={value}
                              label={
                                dataExtensionFile?.find(
                                  (item) => item?.extension == value
                                )?.ghi_chu
                              }
                              onDelete={handleToDelete("extension", value)}
                              deleteIcon={
                                <CancelIcon
                                  onMouseDown={(event) =>
                                    event.stopPropagation()
                                  }
                                />
                              }
                              sx={{
                                fontSize: "0.75rem",
                                height: "1.25rem",
                              }}
                            />
                          ))}
                      </Stack>
                    );
                  }}
                >
                  <MenuItem disabled value={""}>
                    {`--- Chọn thành phần mở rộng file ---`}
                  </MenuItem>
                  {dataExtensionFile &&
                    dataExtensionFile?.length > 0 &&
                    dataExtensionFile?.map((item) => (
                      <MenuItem
                        key={item?.extension + "extension"}
                        value={item?.extension}
                      >
                        <Typography variant="inherit" noWrap>
                          {item?.ghi_chu}
                        </Typography>
                      </MenuItem>
                    ))}
                </Select>
                {errors?.extension && (
                  <FormHelperText sx={{ color: "red", fontSize: "12px" }}>
                    {errors?.extension}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <MDTypography
                variant="h5"
                sx={{
                  textAlign: "center",
                  border: "1px solid #1e3a8a",
                  padding: "0.5rem",
                  borderRadius: "0.5rem",
                  color: "#1e3a8a",
                }}
              >
                Cấu hình Email
              </MDTypography>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Typography
                fontSize={"0.75rem"}
                color={"#000000"}
                fontWeight={500}
              >
                Domain<span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                required
                fullWidth
                name={"domain"}
                value={data?.fields?.domain || ""}
                error={errors ? !!errors?.domain : false}
                placeholder={`Nhập domain`}
                helperText={errors?.domain}
                onChange={handleChangeInput("domain")}
                inputProps={{
                  maxLength: 255,
                }}
                onFocus={handleOnFocus("domain")}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Typography
                fontSize={"0.75rem"}
                color={"#000000"}
                fontWeight={500}
              >
                Email<span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                required
                fullWidth
                name={"email"}
                value={data?.fields?.email || ""}
                error={errors ? !!errors?.email : false}
                placeholder={`Nhập email`}
                helperText={errors?.email}
                onChange={handleChangeInput("email")}
                inputProps={{
                  maxLength: 255,
                }}
                onFocus={handleOnFocus("email")}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Typography
                fontSize={"0.75rem"}
                color={"#000000"}
                fontWeight={500}
              >
                Password<span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                required
                value={data?.fields?.password || ""}
                placeholder="Nhập password"
                onChange={handleChangeInput("password")}
                fullWidth
                name="password"
                type={values.showPass ? "text" : "password"}
                error={errors ? !!errors.password : false}
                helperText={errors?.password}
                onFocus={handleOnFocus("password")}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handlePassVisibilty}
                        aria-label="toggle password"
                        edge="end"
                      >
                        {values.showPass ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Typography
                fontSize={"0.75rem"}
                color={"#000000"}
                fontWeight={500}
              >
                SMTP<span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                required
                fullWidth
                name={"smtp"}
                value={data?.fields?.smtp || ""}
                error={errors ? !!errors?.smtp : false}
                placeholder={`Nhập SMTP`}
                helperText={errors?.smtp}
                onChange={handleChangeInput("smtp")}
                inputProps={{
                  maxLength: 255,
                }}
                onFocus={handleOnFocus("smtp")}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Typography
                fontSize={"0.75rem"}
                color={"#000000"}
                fontWeight={500}
              >
                Port<span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                required
                fullWidth
                name={"port"}
                value={data?.fields?.port || ""}
                error={errors ? !!errors?.port : false}
                placeholder={`Nhập port`}
                helperText={errors?.port}
                onChange={handleChangeInput("port")}
                inputProps={{
                  maxLength: 5,
                }}
                onFocus={handleOnFocus("port")}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                color="primary"
                variant="contained"
                startIcon={<SaveIcon />}
                size="small"
                onClick={onSubmitForm}
                sx={{ color: "#ffffff", float: "right" }}
              >
                Lưu
              </Button>
            </Grid>
          </Grid>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <Box>
            <Typography fontSize={"0.75rem"} color={"#000000"} fontWeight={500}>
              Mẫu Email<span style={{ color: "red" }}>*</span>
            </Typography>
            <div ref={toolBarRef} />
            <CKEditor
              editor={DecoupledEditor}
              data={dataEmail}
              onChange={(event, editor) => {
                const data = editor.getData();
                setDataEmail(data);
              }}
              onReady={(editor) => {
                if (toolBarRef.current) {
                  toolBarRef.current.appendChild(
                    editor.ui.view.toolbar.element
                  );
                }
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "300px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
              // onChange={handleChangeEditor}
              config={{
                simpleUpload: {
                  uploadUrl: API_URL + "/media",
                  headers: {
                    "X-CSRF-TOKEN": "CSRF-Token",
                    Authorization: `Bearer ${accessToken}`,
                  },
                },
              }}
              style={{
                minHeight: "300px",
                border: "1px solid #ccc",
              }}
            />
          </Box>
          <Grid container spacing={2} sx={{ textAlign: "left" }} mt={"0px"}>
            <Grid item xs={12} md={9} lg={9}>
              <Typography
                fontSize={"0.75rem"}
                color={"#000000"}
                fontWeight={500}
              >
                <span style={{ color: "red" }}>*</span>
                <span style={{ color: "red" }}>*</span>
                <span style={{ color: "red" }}>*</span>
                {myString}
              </Typography>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <Button
                type="submit"
                variant="contained"
                startIcon={<SaveIcon />}
                size="small"
                onClick={onSubmitFormEmail}
                sx={{ color: "#ffffff", float: "right", mr: 1 }}
              >
                Lưu
              </Button>
            </Grid>
          </Grid>
        </CustomTabPanel>
      </Box>
      <Footer />
    </DashboardLayout>
  );
}
const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = value > 0 ? true : false;
  }
  return result;
};
const validateEmail = (value) => {
  let result = false;
  if (value && JsonTool.validateEmail(value)) {
    result = true;
  }
  return result;
};
function validateOBJ(setting) {
  return {
    email: !validateRequired(setting.email)
      ? "Email không được trống"
      : validateEmail(setting.email)
      ? "Định dạng Email không đúng"
      : "",
    password: !validateRequired(setting.password) ? "Password được trống" : "",
    port: !validateRequired(setting.port) ? "Port không được trống" : "",
    smtp: !validateRequired(setting.smtp) ? "SMTP không được trống" : "",
    domain: !validateRequired(setting.domain) ? "Domain không được trống" : "",
    image_ext: !validateRequired(setting.image_ext)
      ? "Định dạng file upload không được trống"
      : "",
    folder_upload: !validateRequired(setting.folder_upload)
      ? "Thư mục upload file không được trống"
      : "",
    sonam_hethan: !validateRequired(setting.sonam_hethan)
      ? "Số năm hết hạn tối thiểu phải bằng 1"
      : "",
    dungluong_file_upload: !validateRequired(setting.dungluong_file_upload)
      ? "Dung lượng file cho phép upload"
      : "",
  };
}
